module.exports = __webpack_public_path__ + "static/media/C++.bd0a600e.png";